import React from 'react';
import { connect } from 'react-redux';
import OrdersSection from './ordersSection';

const CONTRACT_TYPES = ['OTC', 'Physical', 'CME'];

class OrdersCommon extends React.Component {
    constructor(props) {
		super(props);
	}

    getOrdersByProductId(id) {
        let { orders } = this.props;
        let result = [];
        if (orders && orders.data && orders.data.length) {
            orders.data.map( item => {
                if (item.product_id == id) result.push(item);
            });
        }
        return result;
    }

    openOrder(id) {
        let { showOrderPopup } = this.props.actions;
        let { mode } = this.props;

        this.props.actions.getOrder(
            id,
            mode,
            showOrderPopup
        );
    }

    createOrder(formData) {  
        this.props.actions.showOrderPopup('create', formData);
    }

    render() {
        let { isOrderPopupVisible } = this.props.orders;         
        let { products } = this.props.user.userInfo;

        products = products || [];
        products.sort((a, b) => a.short_name < b.short_name ? -1 : 1);
        const groups = products.reduce((groups, item) => {
            const val = item['contract_type']
            groups[val] = groups[val] || []
            groups[val].push(item)
            return groups
          }, {});         

        return (
            <div>
                {CONTRACT_TYPES.map(contract_type => 
                    <div key={contract_type}>
                        <div className='contract-type-title'>{groups[contract_type] ? contract_type : ''}</div>
                        {(groups[contract_type] || []).map((item, i) =>                
                            <OrdersSection
                                key={'marketGroup_'+item.id+'_order_'+i}
                                data={item}
                                isSuperUser={this.props.user.isSuperUser}
                                showCounerparty={this.props.showCounerparty}
                                showCreateButton={this.props.orders.type == 'workingOrders'}
                                openOrder={this.openOrder.bind(this)}
                                createOrder={this.createOrder.bind(this, {product_id: item.id})}
                                orders={this.getOrdersByProductId(item.id)} />
                        )}
                    </div>
                )}
            </div>
        )
    }
}

export default OrdersCommon;



// WEBPACK FOOTER //
// ./source/screens/orders/ordersInner.js